import { Box, Card, CardContent, Typography } from '@mui/material';
import React from 'react';

import { ProjectSalesforceInfo } from '../../../../Types/dealGPT';

interface TargetCompanyCardProps {
  salesforce: ProjectSalesforceInfo;
}

const TargetCompanyCard: React.FC<TargetCompanyCardProps> = ({ salesforce }) => {
  return (
    <Card sx={{ width: '100%', minHeight: '140px' }}>
      <CardContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="h5" sx={{ color: '#f900d3' }}>
            Target Company
          </Typography>
          <Box sx={{ display: 'flex', width: '100%', gap: 5 }}>
            <Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column', gap: 1, padding: 1 }}>
              <Typography variant="body1">Account:</Typography>
              <Typography variant="body2">
                {salesforce.PEFirm ?? 'No PE Firm associated. '}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column', gap: 1, padding: 1 }}>
              <Typography variant="body1">Industry:</Typography>
              <Typography variant="body2">
                {salesforce.industry ?? 'No Industry found. '}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column', gap: 1, padding: 1 }}>
              <Typography variant="body1">Sub-Industry:</Typography>
              <Typography variant="body2">
                {salesforce.subIndustry ?? 'No SubIndustry found. '}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column', gap: 1, padding: 1 }}>
              <Typography variant="body1">Revenue Band:</Typography>
              <Typography variant="body2">
                {salesforce.revenueBand ?? 'No Revenue Band found. '}
              </Typography>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TargetCompanyCard;
